<script>
  import { onDestroy } from 'svelte';
  import { fly } from 'svelte/transition';
  import jQuery from 'jquery';
  import NotificationAjax from '@ajax/notification';
  import Modal from '@components/Modal.svelte';
  import Button from '@components/Button.svelte';
  import Link from '@components/Link.svelte';
  import Realtime from '@utils/realtime';
  import Track from '@utils/track';
  import Log from '@utils/log';
  import Cookie from 'js-cookie';
  import ComponentEvents from '@utils/component-events';
  import { browser } from '$app/environment';

  import moment from 'moment';
  import ProfileCopyButton from './buttons/ProfileCopyButton.svelte';
  import { inview } from 'svelte-inview';
  import NotificationsMenuItem from './NotificationsMenuItem.svelte';
  import NotificationGroup from './NotificationGroup.svelte';
  import { getCurrentUserStore } from '@stores/current_user';

  import { getGlobalStore } from '@stores/global';
  import TermsAndPrivacyModal from '@app-components/modal/TermsAndPrivacyModal.svelte';
  import WelcomeVideo from '@app-components/WelcomeVideo.svelte';

  let globalStateStore = getGlobalStore('globalStateStore');
  import queryString from 'query-string';
  let notifType = queryString.parse(location.search).notif_type;
  import jsCookie from 'js-cookie';
  const isBenableUser = jsCookie.get('benable-user') === 'true';

  export let mobile = false;
  export let buttonActive = false;

  let dropdownOpened = false;

  const tsGroups = ['Today', 'Yesterday', 'This week', 'This month', 'Older'];
  let unseenCount = 0;
  let notifications = [];
  let notificationGrouped = {};
  let selectedNotification;
  let user = getCurrentUserStore('default');
  let sub = user.subscribe((x) => (user = x));
  let notificationSlideIn = { x: 0, duration: 0 };
  let loadingNotifications = true;
  let showAnimations = false;
  let topMenuType = null;
  let topMenuItems = [];
  let rightPosition = null;

  let notificationViewed = [];
  let seenInterval;
  let showTermsModal =
    browser && isBenableUser !== true && user && user.id && user.accepted_terms_and_privacy === false;

  let unsubUpdateCount = ComponentEvents.on('update-count', function (count) {
    unseenCount = count;
  });

  let rtNotificationsRefresh = Realtime.subscribe(user, 'notifications:refresh', (uc) => {
    if (uc > 0) {
      unseenCount = uc;
      hasMore = false;
      notificationGrouped = {};
      showAnimations = false;
      notifications = [];
      page = 1;
      loadNotifications();
    }
  });

  const openNewNotification = (notifications) => {
    if (showTermsModal) {
      return;
    }
    let notificationToOpen = notifications.find((n) => {
      return n.open_on_login;
    });

    if (!notificationToOpen) {
      return;
    }

    let last_shown_notification = Date.parse(Cookie.get('current_user_last_shown_notification')) || false;
    let show_notification = true;

    if (last_shown_notification) {
      let last_shown_notification_date = moment(last_shown_notification);
      let one_hour_ago = moment().subtract(5, 'minutes');
      show_notification = one_hour_ago > last_shown_notification_date;
    }

    if (show_notification) {
      notificationClicked(notificationToOpen, false);
      Cookie.set('current_user_last_shown_notification', new Date().toISOString());
    }
  };

  const notificationPath = (notification) => {
    if (notification.button_style === 'image_link') {
      return;
    }

    if (notification.item_detail_path) {
      return notification.item_detail_path;
    }

    if (notification.related_group_path) {
      return notification.related_group_path;
    }

    if (notification.related_user?.profile_path) {
      return notification.related_user?.profile_path;
    }

    if (notification.identifier == 'verification_complete') {
      return user.profile_path;
    }

    if (notification.skip_alert || notification.button_url) {
      let url = notification.button_url;
      return url.replace('{username}', user.username);
    }
  };

  const setNotificationPaths = (notifications) => {
    return notifications.map((notification) => {
      return { ...notification, path: notificationPath(notification) };
    });
  };

  let page = 1;
  let hasMore = false;

  const loadNewNotifications = function () {
    page = page + 1;
    loadNotifications();
  };

  const loadNotifications = async (slideState = null) => {
    loadingNotifications = true;
    const notifs = await NotificationAjax.fetch(page, topMenuType);
    notifications = notifications.concat(notifs['user_notifications']);
    hasMore = notifs['has_more'];
    if (page == 1) {
      topMenuItems = notifs.filters;
      unseenCount = notifs.unseen_count;
    }

    openNewNotification(notifications);
    notifications = setNotificationPaths(notifications);
    notificationGrouped = notifications.reduce(function (r, a) {
      r[a.ts_group] = r[a.ts_group] || [];
      r[a.ts_group].push(a);
      return r;
    }, {});
    if (slideState == 'in') {
      notificationSlideIn = { x: 250, duration: 250 };
    }
    if (slideState == 'out') {
      notificationSlideIn = { x: -250, duration: 250 };
    }
    if (page == 1) {
      showAnimations = true;
    }
    loadingNotifications = false;
  };

  const closeDropdown = () => {
    notificationSlideIn = { x: 0, duration: 0 };
    dropdownOpened = false;
  };

  const setRightPosition = function () {
    if (document.getElementById('notification-bell-button')) {
      const leftDistance =
        window.innerWidth - document.getElementById('notification-bell-button').getBoundingClientRect().left;
      if (leftDistance < 450) {
        rightPosition =
          window.innerWidth - (document.getElementById('notification-bell-button').getBoundingClientRect().left + 45);
      } else {
        rightPosition = null;
      }
    }
  };

  export let openDropdown = () => {
    if (!mobile) {
      setRightPosition();
    }
    NotificationAjax.markAllAsSeen();
    dropdownOpened = true;
    notifications = notifications.map((n) => {
      return { ...n, seen: new Date() };
    });

    Track.notificationMenuOpen({ user: user });
  };

  let toggleDropdown = () => {
    if (dropdownOpened) {
      closeDropdown();
    } else {
      unseenCount = 0;
      openDropdown();
    }
  };

  const goToUrl = (n) => {
    let url = n.button_url;
    url = url.replace('{username}', user.username);
    location.href = url;
  };

  const performAction = (n) => {
    Track.notificationMenuActionClick({ user: user, notification: selectedNotification });
    Log.info(`[NOTIFICATION CLICKED THROUGH] ${user.name} clicked through notification ${selectedNotification.title}`);

    selectedNotification = undefined;
    goToUrl(n);
  };

  const emojiClicked = (n) => {
    if (n.emoji_click_url) {
      window.open(n.emoji_click_url);
    }
  };

  const notificationClicked = (n, followLinks = true) => {
    Track.notificationMenuClick({ user: user, notification: n });
    Log.info(`[NOTIFICATION READ] ${user.name} opened notification ${n.title}`);

    n.id ? NotificationAjax.markClicked(n) : NotificationAjax.createAndMarkClicked(n);

    if (n.log_to_slack) {
      Log.info(`[NOTIFICATION READ] ${user.name} opened notification ${n.title}`, false, '#user-notifications');
    }

    if (n.path && followLinks) {
      if (n.open_in_new_window) {
        window.open(n.path, '_blank');
      } else {
        location.href = n.path;
      }

      return;
    }

    selectedNotification = n;
    n.clicked = new Date();
    notifications = notifications;
  };

  const closeModal = () => {
    selectedNotification = undefined;
    if (mobile) {
      openDropdown();
    }
  };

  const menuItemClicked = function (type) {
    topMenuType = type;
    notifications = [];
    hasMore = false;
    page = 1;
    notificationGrouped = {};
    showAnimations = false;
    loadNotifications('in');
    NotificationAjax.markAllAsSeen(type);
  };

  const backToMainMenu = function () {
    topMenuItems = [];
    topMenuType = null;
    hasMore = false;
    notifications = [];
    page = 1;
    notificationGrouped = {};
    showAnimations = false;
    loadNotifications('out');
  };

  const topMenuTypeCapitalized = function () {
    return topMenuType.charAt(0).toUpperCase() + topMenuType.slice(1);
  };

  const handleMouseEnter = function () {
    if (dropdownOpened && !mobile) {
      jQuery('body').css({ position: 'fixed', 'overflow-y': 'scroll' });
    }
  };

  const handleMouseLeave = function () {
    if (dropdownOpened && !mobile) {
      jQuery('body').css({ position: 'unset', 'overflow-y': 'scroll' });
    }
  };

  let setNotificationViewed = function (n) {
    if (user && user.id && n && n.detail) {
      notificationViewed.push(n.detail.id);
    }
  };

  let setIntervalSeenGroupsToServer = function () {
    seenInterval = setInterval(sendSeenGroupsToServer, 10000);
  };

  let sendSeenGroupsToServer = function () {
    if (notificationViewed.length == 0) {
      return;
    }

    Track.notificationsViewed({ user, notificationIds: notificationViewed });
    notificationViewed = [];
  };

  let openDropdownOnStart = function () {
    menuItemClicked(notifType);
    openDropdown();
    notifType = null;
  };

  let unsubGlobalState = globalStateStore.subscribe((x) => {
    if (x.modalOpen) {
      dropdownOpened = false;
    }
  });

  if (notifType) {
    setTimeout(openDropdownOnStart, 300);
  } else {
    loadNotifications();
  }
  setIntervalSeenGroupsToServer();

  onDestroy(() => {
    rtNotificationsRefresh();
    sub();
    unsubGlobalState();
    unsubUpdateCount && unsubUpdateCount();

    sendSeenGroupsToServer();
    clearInterval(seenInterval);
  });

  if (!mobile) {
    jQuery(window).resize(function () {
      setRightPosition();
    });
  }
</script>

<style style="text/scss" lang="scss">
  @import '../vendor/design-system.scss';

  .notification-bell {
    cursor: pointer;
    position: relative;
    border: none;
    padding: 0px;
    background: white;

    svg {
      stroke: #a19bb8;
    }

    .notification-bell-button {
      width: 34px;
      height: 34px;
      margin: -4px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 9px;
      cursor: pointer;
    }

    .red-icon {
      background: $red-pink;
      border: 2px solid #f9f7ff;
      width: 20px;
      height: 20px;
      position: absolute;
      top: -10px;
      right: -8px;
      border-radius: 8px;
      font-size: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 0px;
      color: white;
      font-weight: 700;
    }
  }

  .notification-bell-no-unseen,
  .notification-bell-with-unseen {
    &:hover {
      svg {
        path {
          stroke: #5e518e;
          opacity: 0.8;
        }
      }
    }

    &.active {
      svg {
        path {
          stroke: #5e518e;
          fill: #5e518e;
          opacity: 1;
        }
      }
    }
  }

  .notification-dropdown {
    position: absolute;
    width: 440px;
    background: #ffffff;
    box-shadow: 0px 22px 100px rgba(0, 0, 0, 0.0938593);
    border-radius: 8px;
    padding-top: 24px;
    padding-bottom: 0px;
    min-height: 300px;
    top: 44px;
    display: none;
    overflow-x: hidden;
    &.desktop {
      z-index: 99999;
    }

    &.visible {
      display: block;
    }
  }

  .notifications-container {
    height: calc(100vh - 205px);
    // min-height: 275px;
    padding-bottom: 8px;
    overflow: hidden;
    overflow-y: auto;
    &.main {
      padding-top: 6px;
    }
    &.nested {
      // min-height: 315px;
      height: calc(100vh - 167px);
    }
  }

  .notification-modal {
    display: flex;
    flex-direction: column;
    align-items: center;

    .notification-modal-emoji {
      width: 80px;
      height: 80px;
      background: #f5f3fc;
      border-radius: 999px;
      padding-left: 22px;
      padding-top: 22px;

      img {
        width: 36px;
        height: 36px;
      }
    }

    .notification-modal-title {
      margin-top: 40px;
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
      text-align: center;
    }

    .notification-modal-description {
      margin-top: 24px;
      font-weight: 400;
      font-size: 16px;
      line-height: 26px;
      text-align: center;
      color: #7f7f7f;
    }

    .notification-modal-image {
      margin-top: 32px;

      img {
        width: 100%;
        object-fit: cover;
        border-radius: 12px;
      }
    }

    .notification-modal-video {
      margin-top: 32px;
      width: 100%;

      iframe {
        border-radius: 12px !important;
      }
    }

    .notification-action {
      margin-top: 40px;
    }
  }

  .mobile-notification-bell {
    width: 24px;
    height: 24px;
    margin-bottom: 0px;

    .notification-bell-button {
      width: unset !important;
      height: unset !important;
      position: unset;

      svg {
        margin-bottom: -4px;
      }
    }

    .notification-dropdown {
      position: fixed;
      top: 0px;
      left: 0px;
      bottom: 0px;
      right: 0px;
      width: 100%;
      height: 100%;
      border-radius: 0px;
      overflow-y: scroll;
      max-height: 100%;
      padding-bottom: 80px;
    }

    .notifications-container {
      height: unset !important;
      overflow: unset !important;
      overflow-x: hidden;
    }
  }

  .follow-dialog-dropdown {
    display: none;
  }

  .notification-header {
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    text-align: left;
    cursor: auto;
    &.nested {
      padding-left: 24px;
      padding-right: 24px;
      margin-bottom: 14px;
    }
    .header-text {
      height: 13px;
      top: 24px;

      font-style: normal;
      font-weight: 700;
      font-size: 11px;
      line-height: 13px;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #000000;
    }
    &.main {
      border-bottom: 1px solid #ececec;
    }

    &.mobile {
      text-align: center;
      margin-bottom: 14px;
      .notification-menu {
        padding: 24px 0;
      }
    }

    .notification-menu {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      padding: 16px 0;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
    }
  }
  .back-button {
    margin-right: 6px;
    padding: 0px;
    cursor: pointer;
  }

  .mobile-header-wrapper--small_case {
    .back-button {
      position: absolute;
    }
  }
  .dropdown-close-button {
    position: absolute;
    cursor: pointer;
    font-weight: 400;
    line-height: 20px;
    font-size: 15px;
    right: 15px;
    top: 15px;
    color: #7f7f7f;
    background: transparent;
    border: 0;
    text-size-adjust: 100%;
    &:hover {
      font-weight: bold;
    }
  }
  .dropdown-close-button::before {
    content: '\2715';
  }

  .notification-menu-desktop {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 16px 24px;
    gap: 12px;
  }
</style>

<TermsAndPrivacyModal mobile={mobile} bind:showModal={showTermsModal} />
<div class="svelte-modal">
  <Modal mobile={mobile} on:close={closeModal} show={selectedNotification}>
    <div slot="content">
      <div class="notification-modal">
        <div
          class="notification-modal-emoji"
          style={selectedNotification.emoji_click_url ? 'cursor: pointer' : ''}
          on:click={() => emojiClicked(selectedNotification)}>
          <img alt="emoji" src={selectedNotification.emoji} />
        </div>
        <div class="notification-modal-title">
          {selectedNotification.title}
        </div>
        {#if selectedNotification.description}
          <div class="notification-modal-description">
            {@html selectedNotification.description}
          </div>
        {/if}
        {#if selectedNotification.button_style === 'profile_link'}
          <ProfileCopyButton mobile={mobile} profileUrl={user.profile_url} />
        {/if}
        {#if selectedNotification.image}
          <div class="notification-modal-image">
            <img
              alt="selected notification"
              src={selectedNotification.image}
              on:click={selectedNotification.button_style == 'image_link'
                ? () => {
                    performAction(selectedNotification);
                  }
                : () => {}} />
          </div>
        {/if}
        {#if selectedNotification.video}
          <div class="notification-modal-video">
            {@html selectedNotification.video}
          </div>
        {/if}
        {#if selectedNotification.button_style === 'button'}
          <div class="notification-action">
            <Button
              style="padding-left: 40px; padding-right: 40px;"
              text={selectedNotification.button_text}
              on:click={performAction(selectedNotification)} />
          </div>
        {:else if selectedNotification.button_style === 'link'}
          <div class="notification-action">
            <Link on:click={performAction(selectedNotification)} text={selectedNotification.button_text} />
          </div>
        {/if}
      </div>
    </div>
  </Modal>
</div>

{#if !mobile && dropdownOpened}
  <div style="position: fixed; top: 0px; bottom: 0px; left: 0px; right: 0px;" on:click={closeDropdown} />
{/if}

<button
  id="notification-bell-button"
  class="notification-bell"
  class:notification-bell-no-unseen={unseenCount === 0}
  class:notification-bell-with-unseen={unseenCount > 0}
  class:active={buttonActive || dropdownOpened}
  class:mobile-notification-bell={mobile}>
  <span on:click={toggleDropdown} class="notification-bell-button">
    {#if mobile}
      {#if !selectedNotification}
        <img
          alt="active"
          src="/images/notifications/{buttonActive || dropdownOpened ? 'bell-active.svg' : 'bell.svg'}" />
      {/if}
    {:else}
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.9462 22.1288C13.7485 22.4698 13.4646 22.7529 13.123 22.9497C12.7814 23.1464 12.3942 23.25 12 23.25C11.6058 23.25 11.2186 23.1464 10.877 22.9497C10.5354 22.7529 10.2515 22.4698 10.0537 22.1288M23.25 17.628H0.75C1.64511 17.628 2.50355 17.2723 3.13649 16.6393C3.76942 16.0063 4.125 15.1477 4.125 14.2524V8.6264C4.125 6.53745 4.95468 4.53405 6.43153 3.05694C7.90838 1.57983 9.91142 0.75 12 0.75C14.0886 0.75 16.0916 1.57983 17.5685 3.05694C19.0453 4.53405 19.875 6.53745 19.875 8.6264V14.2524C19.875 15.1477 20.2306 16.0063 20.8635 16.6393C21.4964 17.2723 22.3549 17.628 23.25 17.628Z"
          stroke="#A19BB8"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    {/if}
  </span>

  {#if unseenCount > 0}
    <div class="red-icon" on:click={toggleDropdown}>
      {unseenCount > 9 ? '9+' : unseenCount}
    </div>
  {/if}

  <div
    style={rightPosition ? `right: -${rightPosition}px;` : ''}
    class="notification-dropdown {topMenuType == null ? 'main' : 'nested'} {mobile ? 'mobile' : 'desktop'}"
    class:visible={dropdownOpened}>
    <div class="notification-content">
      <div class="notification-header {topMenuType == null ? 'main' : 'nested'}" class:mobile={mobile}>
        {#if topMenuType == null}
          {#if mobile}
            <div
              class="mobile-header-wrapper--small_case"
              style="height: unset; padding-left: 24px; padding-right: 24px;">
              <div class="text header-text">NOTIFICATIONS</div>
            </div>
          {:else}
            <div style="padding-left: 24px; padding-right: 24px;">
              <span class="header-text"> NOTIFICATIONS </span>
              <button class="dropdown-close-button" on:click={() => closeDropdown()} />
            </div>
          {/if}
        {:else if mobile}
          <div class="mobile-header-wrapper--small_case" style="height: unset;">
            <img
              class="back-button"
              on:click={() => backToMainMenu()}
              src="/images/switch-accounts-modal/back-black.svg"
              alt="back-button" />
            <div class="text header-text">{topMenuTypeCapitalized()}</div>
          </div>
        {:else}
          <img
            class="back-button"
            on:click={() => backToMainMenu()}
            src="/images/notifications/left-icon.svg"
            alt="back-button" />
          <span on:click={() => backToMainMenu()} style="cursor: pointer;" class="header-text"
            >{topMenuTypeCapitalized()}</span>
          <button class="dropdown-close-button" on:click={() => closeDropdown()} />
        {/if}

        <!-- Current code here -->
        {#if topMenuType == null}
          {#if mobile}
            {#if showAnimations}
              <div class="notification-menu" in:fly={notificationSlideIn}>
                {#each topMenuItems as menuItem}
                  <NotificationsMenuItem
                    enabled={menuItem.enabled}
                    mobile={mobile}
                    menuItemClicked={(t) => menuItemClicked(t)}
                    title={menuItem.title}
                    type={menuItem.type}
                    unreadCount={menuItem.unread_count}
                    iconUrl={menuItem.icon_url} />
                {/each}
              </div>
            {/if}
          {:else}
            <div class="notification-menu-desktop">
              {#each topMenuItems as menuItem}
                <NotificationsMenuItem
                  enabled={menuItem.enabled}
                  mobile={mobile}
                  menuItemClicked={(t) => menuItemClicked(t)}
                  title={menuItem.title}
                  type={menuItem.type}
                  unreadCount={menuItem.unread_count}
                  iconUrl={menuItem.icon_url} />
              {/each}
            </div>
          {/if}
        {/if}
      </div>

      <WelcomeVideo mobile={mobile} mode="notification" />

      <div
        class="notifications-container purple-scrollbar-rounded-light-wide-rounded {topMenuType == null
          ? 'main'
          : 'nested'}"
        on:mouseenter={handleMouseEnter}
        on:mouseleave={handleMouseLeave}>
        {#if showAnimations}
          <div in:fly|global={notificationSlideIn}>
            {#if loadingNotifications == false && notifications.length == 0}
              {#if topMenuType == null}
                <div style="margin-top: 44px; text-align: center;">
                  <img alt="empty" src="/images/notifications/no-notifications.svg" />

                  <div
                    style="font-weight: 500; color: #7F7F7F; {mobile
                      ? 'font-size: 16px; line-height: 24px;'
                      : 'font-size: 14px; line-height: 20px;'}">
                    <div style="margin-top: {mobile ? 54 : 32}px;">No notifications yet!</div>
                    <div style="margin-top: {mobile ? 30 : 24}px;">
                      Stay tuned for announcements, product updates, and more!
                    </div>
                  </div>
                </div>
              {:else}
                <div style="margin-top: 44px; text-align: center;">
                  <div
                    style="font-weight: 500; color: #7F7F7F; {mobile
                      ? 'font-size: 16px; line-height: 24px;'
                      : 'font-size: 14px; line-height: 20px;'}">
                    <div style="margin: 50px;">
                      {topMenuItems.filter((x) => x.type == topMenuType)[0].empty_state}
                    </div>
                  </div>
                </div>
              {/if}
            {/if}

            {#each tsGroups as group}
              {#if notificationGrouped[group]}
                <NotificationGroup
                  on:notification-seen={setNotificationViewed}
                  notificationClicked={notificationClicked}
                  group={group}
                  notifications={notificationGrouped[group]}
                  user={user}
                  mobile={mobile} />
              {/if}
            {/each}
            {#if loadingNotifications}
              <div style="margin-top: 25px; text-align: center;">
                <i class="fa fa-spinner fa-spin" style="color: #1a1a1a;" />
              </div>
            {/if}
            {#if hasMore}
              <div use:inview={{}} on:enter={loadNewNotifications} />
            {/if}
          </div>
        {/if}
      </div>
    </div>
  </div>
</button>
